class MegaMenuElement extends HTMLElement {
  /** @type {NodeListOf<HTMLElement>} */ #items = this.querySelectorAll(
    '[aria-controls^="level3-"]'
  );
  /** @type {HTMLElement|null} */ #activeItem =
    [...this.#items].find((item) => item.ariaExpanded === 'true') ?? null;
  /** @type {HTMLElement|null} */ #activeTarget =
    this.#activeItem === null ? null : this.#getTargetForItem(this.#activeItem);

  connectedCallback() {
    this.#items.forEach((item) => {
      item.addEventListener('mouseenter', () => this.#handleMouseenter(item));
    });
  }

  /**
   * Handle item mouseenter
   * @param {HTMLElement} item
   */
  #handleMouseenter(item) {
    const target = this.#getTargetForItem(item);
    const isHoveredItemAlreadyActive =
      item === this.#activeItem && target !== null && target === this.#activeTarget;

    if (isHoveredItemAlreadyActive) return;

    this.#collapseAllItemTargets();

    if (!target) {
      this.#activeTarget = null;
      this.#activeItem = null;
      return;
    }

    target.ariaExpanded = 'true';
    item.ariaExpanded = 'true';

    this.#activeTarget = target;
    this.#activeItem = item;
  }

  #collapseAllItemTargets() {
    this.#items.forEach((item) => {
      item.ariaExpanded = 'false';
      const target = this.#getTargetForItem(item);
      if (target) target.ariaExpanded = 'false';
    });
  }

  /**
   * Get the associated level 3 panel from a level 2 item.
   * @param {HTMLElement} item
   * @returns {HTMLElement|null}
   */
  #getTargetForItem(item) {
    const targetId = item.getAttribute('aria-controls');
    if (targetId === null || targetId === '') return null;

    return this.querySelector(`#${targetId}`);
  }

  // Called from header-navigation.js when the mega menu is closed
  collapseAll() {
    this.#collapseAllItemTargets();
    this.#activeTarget = null;
    this.#activeItem = null;
  }
}

customElements.define('mega-menu-element', MegaMenuElement);
